import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getProStock } from '../../../../Store/prosafe/proStock/getProStock';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';
import Loader from '../../Include/Loader';
import { Pagination } from '../../Table';
import { ArrowDown, ArrowUp, Layers, PackageCheck } from 'lucide-react';
import PageHeader from '../../Components/PageHeader/PageHeader';
import useDebounce from '../../../../hooks/useDebounce';
import { getAdminItem } from '../../../../Store/Store/Item/AdminItem';
import { getProject } from '../../../../Store/Store/Project/Project';
import { getCategory } from '../../../../Store/Store/StoreMaster/Category/Category';
import { V_URL } from '../../../../BaseUrl';
import axios from 'axios';
import toast from 'react-hot-toast';


const ProStockList = () => {

    const dispatch = useDispatch();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setlimit] = useState(10);
    const [search, setSearch] = useState("");


    const [filter, setFilter] = useState({
        startDate: null,
        endDate: null,
        item: null,
        category: null,
        project: null,
    });

    const debouncedSearch = useDebounce(search, 500);

    useEffect(() => {
        fetchData();
    }, [debouncedSearch, filter, currentPage, limit]);

    useEffect(() => {
        dispatch(getAdminItem({ is_main: true }));
        dispatch(getProject());
        dispatch(getCategory());
    }, [dispatch]);

    const fetchData = () => {
        const payload = {
            firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
            year_id: localStorage.getItem('PAY_USER_YEAR_ID'),
            search: debouncedSearch,
            start_date: filter.startDate,
            end_date: filter.endDate,
            item_id: filter.item,
            item_category_id: filter.category,
            project_id: filter.project,
            page: currentPage,
            limit: limit
        }

        dispatch(getProStock({ formData: payload }))
    };

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setCurrentPage(1);
    };

    const entity = useSelector((state) => state.getProStock?.user?.data);
    const isLoading = useSelector((state) => state?.getProStock?.loading);
    const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
    const projectData = useSelector((state) => state?.getProject?.user?.data);
    const categoryData = useSelector((state) => state?.getCategory?.user?.data);

    const commentsData = entity?.data?.store_items || [];

    useEffect(() => {
        if (entity?.pagination) {
            setTotalItems(entity?.pagination?.totalCount);
        }
    }, [entity?.pagination]);

    const handleRefresh = () => {
        setFilter({
            startDate: null,
            endDate: null,
            item: null,
            category: null,
            project: null,
        });
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    const filterConfig = [
        {
            key: "item",
            label: "Item",
            type: "dropdown",
            value: filter.item,
            placeholder: "Select Item",
            searchable: true,
            options:
                itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
        },
        {
            key: "category",
            label: "Item Category",
            type: "dropdown",
            value: filter.category,
            placeholder: "Select Item Category",
            searchable: true,
            options:
                categoryData?.map((category) => ({
                    label: category.name,
                    value: category._id,
                })) || [],
        },
        {
            key: "project",
            label: "Project",
            type: "dropdown",
            value: filter.project,
            placeholder: "Select Project",
            searchable: true,
            options:
                projectData?.map((project) => ({
                    label: `${project.name} (${project.project_no})`,
                    value: project._id,
                })) || [],
        },
        {
            key: "startDate",
            label: "Start Date",
            type: "date",
            value: filter.startDate,
            placeholder: "Select Start Date",
        },
        {
            key: "endDate",
            label: "End Date",
            type: "date",
            value: filter.endDate,
            placeholder: "Select End Date",
        },
    ];

    const handleDownloadExcel = async () => {
        try {
            const payload = {
                search,
                start_date: filter.startDate,
                end_date: filter.endDate,
                item_id: filter.item,
                item_category_id: filter.category,
                project_id: filter.project,
                firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
                year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
            };

            const res = await axios.post(
                `${V_URL}/prosafe/pro-ms-stock-xlsx-download`,
                payload,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                    },
                }
            );

            if (res?.data) {
                window.open(res?.data?.data?.url);
                toast.success(res?.data?.message || "Excel downloaded successfully");
            } else {
                toast.error("Failed to download");
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || "Download failed");
        }
    };

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">Stock</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 mb-3">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                <div className="card-body d-flex align-items-center">
                                    <div className="bg-primary text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                        <Layers size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 text-muted">Opening Balance</h6>
                                        <h5 className="mb-0">{entity?.data?.total_op_bal || 0}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                <div className="card-body d-flex align-items-center">
                                    <div className="bg-success text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                        <ArrowDown size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 text-muted">Total In</h6>
                                        <h5 className="mb-0">{entity?.data?.total_in || 0}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                <div className="card-body d-flex align-items-center">
                                    <div className="bg-danger text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                        <ArrowUp size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 text-muted">Total Out</h6>
                                        <h5 className="mb-0">{entity?.data?.total_out || 0}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                <div className="card-body d-flex align-items-center">
                                    <div className="bg-warning text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                        <PackageCheck size={24} />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 text-muted">Total Balance</h6>
                                        <h5 className="mb-0">{entity?.data?.total_balance || 0}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-table show-entire">
                                <div className="card-body">

                                    <PageHeader
                                        title="Stock"
                                        onSearch={(value) => {
                                            setSearch(value);
                                            setCurrentPage(1);
                                        }}
                                        onRefresh={handleRefresh}
                                        filter={filter}
                                        onFilterChange={handleFilterChange}
                                        limit={limit}
                                        onLimitChange={(val) => setlimit(val)}
                                        filterConfig={filterConfig}
                                        onDownload={handleDownloadExcel}
                                    />
                                    {!isLoading ? (
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Item Name</th>
                                                        <th>Category</th>
                                                        <th>Opening Balance</th>
                                                        <th>Total In</th>
                                                        <th>Total Out</th>
                                                        <th>Balance</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) => (
                                                        <tr key={elem?.item_id || i}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.item_name || '-'}</td>
                                                            <td>{elem?.category || '-'}</td>
                                                            <td>{elem?.opening_balance ?? 0}</td>
                                                            <td>{elem?.date_totalIn ?? 0}</td>
                                                            <td>{elem?.date_totalOut ?? 0}</td>
                                                            <td>{elem?.balance ?? 0}</td>
                                                        </tr>
                                                    ))}
                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : <Loader />}

                                    <div className="row align-center mt-3 mb-2">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate">
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ProStockList